import { useEffect, useState } from "react";



import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";



import ToolbarButton from "./toolbar-button";


const DEFAULT_WIDTH = "500";
const DEFAULT_HEIGHT = "1000";

const PageSize: React.FC<
  React.ComponentProps<"div"> & {
    editorRef: React.RefObject<HTMLDivElement>;
  }
> = ({ editorRef }) => {
  const [size, setSize] = useState({
    width: DEFAULT_WIDTH,
    minHeight: DEFAULT_HEIGHT
  });

  const [isFullScreen, setFullScreen] = useState(false);
  const [isModal, setModal] = useState(false);
  const [isUserImage, setUserImage] = useState(false);

  useEffect(() => {
    if (!editorRef.current) return;

    const width =
      editorRef.current.style.width.replace(/px/g, "") || DEFAULT_WIDTH;

    const minHeight =
      editorRef.current.style.minHeight.replace(/px/g, "") || DEFAULT_HEIGHT;

    const fullScreen =
      editorRef.current.getAttribute("data-isfullscreen") === "true";

    const modal = editorRef.current.getAttribute("data-ismodal") === "true";

    const userImage =
      editorRef.current.getAttribute("data-isuserimg") === "true";

    setSize({
      width,
      minHeight
    });

    setFullScreen(fullScreen);
    setModal(modal);
    setUserImage(userImage);
  }, [editorRef]);

  // useEffect(() => {
  //   if (!editorRef.current) return;

  //   if (!isFullScreen) {
  //     editorRef.current.style.width = `${size.width}px`;
  //     editorRef.current.style.minHeight = `${size.minHeight}px`;

  //     editorRef.current.setAttribute("data-isfullscreen", "false");
  //   } else {
  //     // editorRef.current.style.removeProperty("width");
  //     editorRef.current.style.removeProperty("min-width");

  //     editorRef.current.setAttribute("data-isfullscreen", "true");
  //   }

  //   editorRef.current.setAttribute(`data-ismodal`, isModal ? "true" : "false");

  //   editorRef.current.setAttribute(
  //     "data-isuserimg",
  //     isUserImage ? "true" : "false"
  //   );
  // }, [size, isFullScreen, isModal, isUserImage, editorRef]);

  useEffect(() => {
    if (!editorRef.current) return;

    if (!isFullScreen) {
      editorRef.current.style.width = `${size.width}px`;
      editorRef.current.style.minWidth = `${size.width}px`;
      editorRef.current.style.minHeight = `${size.minHeight}px`;

      editorRef.current.setAttribute("data-isfullscreen", "false");
    } else {
      editorRef.current.style.width = "100%";
      editorRef.current.style.minWidth = "100%";
      editorRef.current.setAttribute("data-isfullscreen", "true");
    }

    editorRef.current.setAttribute("data-ismodal", isModal ? "true" : "false");

    editorRef.current.setAttribute(
      "data-isuserimg",
      isUserImage ? "true" : "false"
    );
  }, [size, isFullScreen, isModal, isUserImage, editorRef]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <ToolbarButton className="flex w-fit items-center gap-x-1">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 3H5C3.89543 3 3 3.89543 3 5V9"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M15 3H19C20.1046 3 21 3.89543 21 5V9"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M21 15V19C21 20.1046 20.1046 21 19 21H15"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M9 21H5C3.89543 21 3 20.1046 3 19V15"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M8 8L3 3"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
            />

            <path
              d="M16 8L21 3"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
            />

            <path
              d="M16 16L21 21"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
            />

            <path
              d="M8 16L3 21"
              stroke="#273646"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
          Size
        </ToolbarButton>
      </PopoverTrigger>

      <PopoverContent className="grid w-64 grid-cols-2 gap-2">
        <Input
          type="number"
          min={0}
          max={2000}
          value={size.width}
          onChange={(e) =>
            setSize((prev) => ({
              ...prev,
              width: e.target.value
            }))
          }
        />

        <Input
          type="number"
          min={0}
          max={3000}
          value={size.minHeight}
          onChange={(e) =>
            setSize((prev) => ({
              ...prev,
              minHeight: e.target.value
            }))
          }
        />

        <div className="col-span-3 flex w-full justify-center">
          <div className="w-20 text-center">
            <Input
              type="checkbox"
              onChange={(e) => setFullScreen(e.target.checked)}
              className="mt-2 h-5"
              checked={isFullScreen}
            />
            <span className="mt-2 text-xs">Full Screen</span>
          </div>

          <div className="w-20 text-center">
            <Input
              type="checkbox"
              onChange={(e) => setModal(e.target.checked)}
              className="mt-2 h-5"
              checked={isModal}
            />
            <span className="mt-2 text-xs">Modal</span>
          </div>

          <div className="w-20 text-center">
            <Input
              type="checkbox"
              onChange={(e) => setUserImage(e.target.checked)}
              className="mt-2 h-5"
              checked={isUserImage}
            />
            <span className="mt-2 text-xs">User Image</span>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default PageSize;